module.exports = __webpack_public_path__ + "img/lnk-sales-force.0a98556b.svg";